import React from "react";

export default function NoPage(){
    return (
        <React.Fragment>
            <h2>Page not found.</h2>
        </React.Fragment>
    );
}